import Core from '../plugin-core-system/core.class.js';

export default class CsScrollbar extends Core {

  /**
   * recalculates and sets css variable
   */
  static setScrollbarScreenWidth() {
    const scrollbarWidth = 2 * Math.round((window.innerWidth - document.body.clientWidth) / 2);

    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
  }

  init() {
    CsScrollbar.setScrollbarScreenWidth();

    window.addEventListener('resize', function() {
      CsScrollbar.setScrollbarScreenWidth();
    });
  }
}
